import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateImageCompressionSettings } from "../openapi/api-client.ts";
import { components } from "../openapi/generated-types.ts";

export const useUpdateImageCompressionSettings = (
  projectId: string,
  appInstallationId: string,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      settings: components["schemas"]["ImageCompressionSettings"],
    ) => {
      return updateImageCompressionSettings(settings, {
        path: { projectId, appInstallationId },
      });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [
          "imageCompressionSettings",
          { projectId, appInstallationId },
        ],
      });
    },
  });
};
